import { render } from "./FpFlipBook.vue?vue&type=template&id=791ac827&scoped=true"
import script from "./FpFlipBook.vue?vue&type=script&lang=js"
export * from "./FpFlipBook.vue?vue&type=script&lang=js"

import "./FpFlipBook.vue?vue&type=style&index=0&id=791ac827&scoped=true&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-791ac827"]])

export default __exports__